import { ActorRole, DealState } from '@/lib/graphql/generated/graphql';
import { atom } from 'jotai';

import { dealStateState } from './deal-state.state';
import { editionModeState } from './edition-mode.state';
import { hasProductErrorsAtom } from './has-product-errors.state';
import { hasSelectedProductsAtom } from './has-selected-products.state';
import { dealItemsStreamingState, productsState } from './products.state';

export type ValidateBrandButtonAtomValue = {
  shouldRender: boolean;
  /** Product/workflow only; combine with `useIsOfferLocked()` for the button. */
  isDisabledFromData: boolean;
};

export const validateBrandButtonAtom = atom<ValidateBrandButtonAtomValue>(
  (get) => {
    const products = get(productsState);
    const dealState = get(dealStateState);
    const editionMode = get(editionModeState);
    const hasProductErrors = get(hasProductErrorsAtom);

    const shouldRender =
      products.length > 0 &&
      editionMode === ActorRole.Brand &&
      dealState !== DealState.NegotiationClosed;

    if (!shouldRender) {
      return { shouldRender: false, isDisabledFromData: true };
    }

    const hasSelectedProducts = get(hasSelectedProductsAtom);
    const isStreaming = get(dealItemsStreamingState);

    const isDisabledFromData =
      isStreaming ||
      !hasSelectedProducts ||
      hasProductErrors ||
      dealState === DealState.ScrapingInProgress;

    return { shouldRender: true, isDisabledFromData };
  }
);
